const LOGIN_USER_FULFILLED = 'LOGIN_USER_FULFILLED';

export const sentryActionTransformer = action => {
  if (action?.type !== LOGIN_USER_FULFILLED) return action;
  return { type: action.type, payload: { loginMethod: action.payload?.loginMethod } };
};
